<button mat-icon-button (click)="openInfoDialog()">
    <mat-icon>info</mat-icon>
</button>
